// extracted by mini-css-extract-plugin
export var navItem = "Navbar-module--navItem--Z31SP";
export var navItemHome = "Navbar-module--navItemHome--ucJ3I";
export var navbar = "Navbar-module--navbar--eORoi";